import * as React from 'react';
import * as _ from 'lodash';
import { connect, Dispatch } from "react-redux";
import { Button, Col, ControlLabel, Form, FormGroup, Modal, Panel } from "react-bootstrap";
import { IApplicationState, AppActionCreators, IQaRegistrationState, QaRegistrationActionCreators } from "@nkr/store/index";
import {
    IQaRegistrationGetRegistrationStepsResponse, IQaRegistrationRegistrationStep,
    IQaRegistrationSetRegistrationStepResponse, IQaRegistrationCreateRegistrationResponse,
    IQaRegistrationGetRegistrationResponse, IQaRegistrationGetCentersResponse, ICenter, IRegistration
} from '@nkr/models/index';
import { RegistrationStep, QaRegistrationFormState } from '@nkr/enums/index';

interface IOwnProps { }

interface IQaRegistrationStateProps {
    registrationSteps: IQaRegistrationState
}

interface IQaRegistrationDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getRegistrationSteps: () => Promise<IQaRegistrationGetRegistrationStepsResponse>,
    setRegistrationStep: (registrationStep: RegistrationStep, id: number, editKey: string, formState: QaRegistrationFormState) => Promise<IQaRegistrationSetRegistrationStepResponse>,
    getPwlSteps: () => Promise<IQaRegistrationGetRegistrationStepsResponse>,
    getCenters: () => Promise<IQaRegistrationGetCentersResponse>,
    createRegistration: (registration: IRegistration, url: string) => Promise<IQaRegistrationCreateRegistrationResponse>,
    getRegistration: (id: number, editkey: string) => Promise<IQaRegistrationGetRegistrationResponse>
}

type TQaRegistrationProps = IQaRegistrationStateProps & IQaRegistrationDispatchProps & IOwnProps

interface IState {
    firstName: string,
    lastName: string,
    email: string,
    registrationUrl: string,
    activeTabIndex: number,
    registrationSteps: IQaRegistrationRegistrationStep[],
    id: number,
    editkey: string,
    selectedRegistrationStep: RegistrationStep,
    selectedCenterId: number,
    pwlSteps: IQaRegistrationRegistrationStep[],
    centers: ICenter[],
    selectedPwlStepId: number,
    showActions: boolean,
    showPwl: boolean,
    showModal: boolean,
    modalMessage: string
}

class QaRegistration extends React.Component<TQaRegistrationProps, IState> {
    readonly state: IState = {
        firstName: "",
        lastName: "",
        email: "",
        registrationUrl: "",
        activeTabIndex: 0,
        registrationSteps: [],
        id: __ENVIRONMENT__ == 'dev' ? 129158 : 29343,
        editkey: __ENVIRONMENT__ == 'dev' ? 'D6C2D19BE17EB72E' : "9999999999999999",
        selectedRegistrationStep: RegistrationStep.NotSelected,
        selectedCenterId: -1,
        pwlSteps: [],
        centers: [],
        selectedPwlStepId: -1,
        showActions: false,
        showPwl: false,
        showModal: false,
        modalMessage: ""
    }

    componentDidMount() {
        this.getData();
    }

    setRegistrationStepClick = (el: React.FormEvent<HTMLButtonElement>) => {
        try {
            let formState: QaRegistrationFormState = parseInt(el.currentTarget.value);
            let registrationStep: RegistrationStep = this.state.selectedRegistrationStep;

            if (this.state.id == 0) {
                throw "Please enter a valid id";
            }

            if (this.state.editkey.trim() == "") {
                throw "Please enter a valid edit key link";
            }

            if (this.state.selectedRegistrationStep == -1) {
                throw "Please select a registration step"
            }

            this.props.showLoading().then(() => {
                this.props.setRegistrationStep(registrationStep, this.state.id, this.state.editkey, formState).then(response => {
                    if (response.data.success) {
                        window.open(response.data.results, '_blank');
                    }

                    this.props.hideLoading();
                });
            }).catch(() => {
                this.props.hideLoading();
            });
        }
        catch (ex) {
            this.showModal(ex);
        }
    }

    retrieveRegistrationClick = () => {
        this.props.showLoading('Getting DASH registration, one moment please...').then(() => {
            this.props.getRegistration(this.state.id, this.state.editkey).then(response => {
                if (response.data.success) {
                    let registrationResult = response.data.results;
                    let url = window.location.href;
                    let urlResult = url.substring(0, url.indexOf("//")) + "//" + this.getDomain(registrationResult.entryDomain) + '/register/donate-kidney/' + registrationResult.id + '/' + registrationResult.editKey;

                    this.setState({
                        activeTabIndex: 0,
                        id: registrationResult.id,
                        editkey: registrationResult.editKey,
                        firstName: registrationResult.firstName,
                        lastName: registrationResult.lastName,
                        registrationUrl: urlResult,
                        email: registrationResult.email,
                        selectedRegistrationStep: registrationResult.currentRegistrationStep,
                        showActions: true
                    });
                } else {
                    this.showModal("Invalid Registration.");
                }

                this.props.hideLoading();
            });
        }).catch(() => {
            this.props.hideLoading();
        });
    }

    createRegistrationClick = () => {
        let { firstName, lastName, email, selectedCenterId: centerId } = this.state;

        let registration: IRegistration = {
            id: -1,
            firstName,
            lastName,
            email,
            centerId,
            middleInitial: '',
            phoneNumber: '',
            phoneNumberSecondary: '',
            isPrivateLabel: false,
            editKey: '',
            currentRegistrationStep: -1,
            entryDomain: ''
        };

        let url = window.location.href;

        let isValid = firstName != '' && lastName != '' && email != '' && centerId > 0;

        if (isValid) {
            this.props.showLoading('Creating registration, one moment please...').then(() => {
                this.props.createRegistration(registration, url).then((response: IQaRegistrationCreateRegistrationResponse) => {
                    if (response.data.success) {
                        let registrationResult = response.data.results;
                        let urlResult = url.substring(0, url.indexOf("//")) + "//" + registrationResult.entryDomain + '/register/donate-kidney/' + registrationResult.id + '/' + registrationResult.editKey;

                        this.setState({
                            activeTabIndex: 0,
                            id: registrationResult.id,
                            editkey: registrationResult.editKey,
                            showActions: true,
                            firstName: registrationResult.firstName,
                            lastName: registrationResult.lastName,
                            email: registrationResult.email,
                            registrationUrl: urlResult,
                            selectedRegistrationStep: registrationResult.currentRegistrationStep
                        });

                        this.showModal("Registration Successfully created. Go to 'Registration Link' tab to view basic data and actions.")
                    }

                    this.props.hideLoading();
                });
            }).catch(() => {
                this.props.hideLoading();
            });
        } else {
            this.setState({
                showModal: true,
                modalMessage: 'Please verify that the following fields are completed: first name, last name, email, center'
            });
        }
    }

    createRegistrationValueChange = (el: React.FormEvent<HTMLInputElement>) => {
        let elementName = el.currentTarget.name;
        let elementValue = el.currentTarget.value;

        switch (elementName) {
            case "firstName":
                this.setState({ firstName: elementValue });
                break;
            case "lastName":
                this.setState({ lastName: elementValue });
                break;
            case "email":
                this.setState({ email: elementValue });
                break;
        }
    }

    registrationStepChange = (el: React.FormEvent<HTMLSelectElement>) => {
        let registrationStep = parseInt(el.currentTarget.value);

        this.setState({
            selectedRegistrationStep: registrationStep,
            showPwl: registrationStep == RegistrationStep.PreWorkupLabs
        });
    }

    centerChange = (el: React.FormEvent<HTMLSelectElement>) => {
        let centerId = parseInt(el.currentTarget.value);

        this.setState({
            selectedCenterId: centerId
        });
    }

    pwlStepChange = (el: React.FormEvent<HTMLSelectElement>) => {
        let pwlStep = parseInt(el.currentTarget.value);

        this.setState({
            selectedPwlStepId: pwlStep
        });
    }

    idChange = (el: React.FormEvent<HTMLInputElement>) => {
        let elementValue = parseInt(el.currentTarget.value);

        this.setState({
            id: elementValue
        });
    }

    editKeyChange = (el: React.FormEvent<HTMLInputElement>) => {
        let elementValue = el.currentTarget.value;

        this.setState({
            editkey: elementValue
        });
    }

    modalOnHide = () => {
        //return;
    }

    showModal = (message: string) => {
        this.setState({
            showModal: true,
            modalMessage: message
        });
    }

    hideModal = () => {
        this.setState({
            showModal: false,
            modalMessage: ""
        });
    }

    getDomain = (entryDomain: string) => {
        let results = entryDomain;
        let domains = ['.org', '.staging', '.dev', '.local:44305', '.local'];

        for (let i = 0; i < domains.length; i++) {
            let domain = domains[i];

            if (results.indexOf(domain) >= 0) {
                results = results.replace(domain, __HIGH_LEVEL_DOMAIN__);
                break;
            }
        }

        return results;
    }

    getData = () => {
        this.props.showLoading("Getting Data...").then(() => {
            Promise.all([
                this.props.getRegistrationSteps(),
                this.props.getPwlSteps(),
                this.props.getCenters()
            ]).then((response: [IQaRegistrationGetRegistrationStepsResponse, IQaRegistrationGetRegistrationStepsResponse, IQaRegistrationGetCentersResponse]) => {
                let [getQaRegistrationStepsResponse, getQaPwlStepsResponse, getQaRegistrationCentersResponse] = response;

                let registrationSteps = getQaRegistrationStepsResponse.data.results;
                let pwlSteps = getQaPwlStepsResponse.data.results;
                let centers = getQaRegistrationCentersResponse.data.results;

                this.setState({
                    registrationSteps,
                    pwlSteps,
                    centers
                })

                this.props.hideLoading();
            }).catch(() => {
                this.props.hideLoading();
            });
        }).catch(() => {
            this.props.hideLoading();
        });
    }

    render = () => {
        let centerList = _.sortBy(this.state.centers, item => item.alias);

        return (
            <div className="container">
                <div className="row">
                    <ul className="nav nav-tabs" style={{ marginBottom: 30 }}>
                        <li className={this.state.activeTabIndex == 0 ? "active" : ""}><a data-toggle="tab" href="#registrationLinkTab">Registration Link</a></li>
                        <li className={this.state.activeTabIndex == 1 ? "active" : ""}><a data-toggle="tab" href="#createNewRegistrationTab">Create New Registraion</a></li>
                        <li className={this.state.activeTabIndex == 2 ? "active" : ""}><a data-toggle="tab" href="#cronTab">Crons</a></li>
                    </ul>
                    <div className="tab-content">
                        <div id="registrationLinkTab" className={this.state.activeTabIndex == 0 ? "tab-pane fade in active" : "tab-pane fade"}>
                            <div className='well' style={{ display: 'flex', paddingTop: 7.5, paddingBottom: 7.5 }}>
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                                    <div style={{ marginRight: 5 }}><strong>ID:</strong></div>
                                    <div>
                                        <input type="text" className="form-control" name="RegistrationId" value={this.state.id} onChange={this.idChange} placeholder="" />
                                    </div>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                                    <div style={{ marginRight: 5 }}><strong>Edit Key:</strong></div>
                                    <div>
                                        <input type="text" className="form-control" name="RegistrationEditKey" value={this.state.editkey} onChange={this.editKeyChange} placeholder="" />
                                    </div>
                                </div>

                                <div>
                                    <Button bsStyle='success' onClick={this.retrieveRegistrationClick}>Retrieve Registration</Button>
                                </div>
                            </div>

                            <Panel>
                                <Panel.Heading>
                                    <Panel.Title>Basic Info</Panel.Title>
                                </Panel.Heading>
                                <Panel.Body>
                                    <div className="row">
                                        <div className="form-group">
                                            <div className='col-xs-12 col-lg-2'><strong>First Name:</strong></div>
                                            <div className='col-xs-12 col-lg-10'>{this.state.firstName}</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group">
                                            <div className='col-xs-12 col-lg-2'><strong>Last Name:</strong></div>
                                            <div className='col-xs-12 col-lg-10'>{this.state.lastName}</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group">
                                            <div className='col-xs-12 col-lg-2'><strong>Email:</strong></div>
                                            <div className='col-xs-12 col-lg-10'>{this.state.email}</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group">
                                            <div className='col-xs-12 col-lg-2'><strong>URL:</strong></div>
                                            <div className='col-xs-12 col-lg-10'><a target="_blank" href={this.state.registrationUrl}>{this.state.registrationUrl}</a></div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group">
                                            <div className='col-xs-12 col-lg-2' style={{ marginTop: 7 }}><strong>Current Registration Step:</strong></div>
                                            <div className="col-xs-12 col-lg-10">
                                                <select
                                                    className="form-control"
                                                    value={this.state.selectedRegistrationStep}
                                                    onChange={this.registrationStepChange}
                                                >
                                                    <option value={-1} selected={this.state.selectedRegistrationStep == -1} >- Select Step -</option>
                                                    {this.state.registrationSteps.map(registrationStep =>
                                                        <option value={registrationStep.registrationStepId}>{registrationStep.registrationStepId} {registrationStep.registrationStepName}</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    {this.state.showPwl && (
                                        <div className="row">
                                            <div className="form-group">
                                                <div className='col-xs-12 col-lg-2' style={{ marginTop: 7 }}><strong>PWL Step:</strong></div>
                                                <div className="col-xs-12 col-lg-10">
                                                    <select className="form-control" value={this.state.selectedPwlStepId} onChange={this.pwlStepChange}>
                                                        <option value={-1} selected={this.state.selectedRegistrationStep == -1} >- Select Step -</option>
                                                        {this.state.pwlSteps.map(pwlStep =>
                                                            <option value={pwlStep.registrationStepId} selected={this.state.selectedPwlStepId == pwlStep.registrationStepId} > {pwlStep.registrationStepName}</option>
                                                        )}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="row">
                                        <div className='col-xs-12 col-lg-2'><strong>Actions:</strong></div>
                                        <div className="col-xs-12 col-lg-10">
                                            <button className="btn btn-primary" style={{ marginBottom: 10, width: 310 }} value={QaRegistrationFormState.Empty} onClick={this.setRegistrationStepClick}>Empty Form</button><br />
                                            <button className="btn btn-primary" style={{ marginBottom: 10, width: 310 }} value={QaRegistrationFormState.FullyCompleteSubQuestionsNotNeeded} onClick={this.setRegistrationStepClick}>Complete Form No Need for Sub Questions</button><br />
                                            <button className="btn btn-primary" style={{ marginBottom: 10, width: 310 }} value={QaRegistrationFormState.FullyCompleteSubQuestionsMissing} onClick={this.setRegistrationStepClick}>Complete Form Missing Sub Questions</button><br />
                                            <button className="btn btn-primary" style={{ marginBottom: 10, width: 310 }} value={QaRegistrationFormState.FullyCompleteSubQuestionsAnswered} onClick={this.setRegistrationStepClick}>Complete Form All Sub Question Answered</button><br />
                                        </div>
                                    </div>
                                </Panel.Body>
                            </Panel>
                        </div>

                        <div id="createNewRegistrationTab" className={this.state.activeTabIndex == 1 ? "tab-pane fade in active" : "tab-pane fade"}>
                            <Form horizontal>
                                <FormGroup>
                                    <Col xs={12} lg={2} componentClass={ControlLabel}>First Name:</Col>
                                    <Col xs={12} lg={10}>
                                        <input type="text" className="form-control" name="firstName" onChange={this.createRegistrationValueChange} placeholder="" />
                                    </Col>
                                </FormGroup>

                                <FormGroup>
                                    <Col xs={12} lg={2} componentClass={ControlLabel}>Last Name:</Col>
                                    <Col xs={12} lg={10}>
                                        <input type="text" className="form-control" name="lastName" onChange={this.createRegistrationValueChange} placeholder="" />
                                    </Col>
                                </FormGroup>

                                <FormGroup>
                                    <Col xs={12} lg={2} componentClass={ControlLabel}>Email:</Col>
                                    <Col xs={12} lg={10}>
                                        <input type="text" className="form-control" name="email" onChange={this.createRegistrationValueChange} placeholder="" />
                                    </Col>
                                </FormGroup>

                                <FormGroup>
                                    <Col xs={12} lg={2} componentClass={ControlLabel}>Center:</Col>
                                    <Col xs={12} lg={10}>
                                        <select className="form-control" value={this.state.selectedCenterId} onChange={this.centerChange}>
                                            <option value={-1} selected={this.state.selectedCenterId == -1} >- Select Center -</option>
                                            {centerList.map(center =>
                                                <option value={center.id} selected={this.state.selectedCenterId == center.id} > {center.alias + ' (' + center.dashDomain + ')'}</option>
                                            )}
                                        </select>
                                    </Col>
                                </FormGroup>

                                <div className="row" style={{ marginTop: 20 }}>
                                    <div className="col-xs-12 text-center">
                                        <button type='button' className="btn btn-primary" style={{ marginBottom: 10, width: 310 }} onClick={this.createRegistrationClick}>Create Registration</button>
                                    </div>
                                </div>
                            </Form>
                        </div>

                        <div id="cronTab" className={this.state.activeTabIndex == 2 ? "tab-pane fade in active" : "tab-pane fade"}>
                            <div className="row" style={{ marginTop: 20 }}>
                                <div className="form-group col-xs-6">
                                    <label className="control-label">Cron:</label>
                                    <select className="form-control" value={this.state.selectedCenterId} onChange={this.centerChange}>
                                        <option value={-1} selected={true} >- Select Cron -</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal bsSize="lg" show={this.state.showModal} onHide={this.modalOnHide}>
                    <Modal.Header>
                        <Modal.Title>Validation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.modalMessage}
                    </Modal.Body>
                    <Modal.Footer >
                        <button className="btn btn-primary" onClick={this.hideModal}>Ok</button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IQaRegistrationStateProps => {
    return {
        registrationSteps: appState.registrationSteps
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IQaRegistrationDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        getRegistrationSteps: () => { return dispatch(QaRegistrationActionCreators.getRegistrationSteps()); },
        setRegistrationStep: (registrationStep: RegistrationStep, id: number, editKey: string, formState: QaRegistrationFormState): Promise<IQaRegistrationSetRegistrationStepResponse> => { return dispatch(QaRegistrationActionCreators.setRegistrationStep(registrationStep, id, editKey, formState)) },
        getPwlSteps: () => { return dispatch(QaRegistrationActionCreators.getPwlSteps()); },
        getCenters: () => { return dispatch(QaRegistrationActionCreators.getCenters()) },
        createRegistration: (registration: IRegistration, url: string): Promise<IQaRegistrationCreateRegistrationResponse> => { return dispatch(QaRegistrationActionCreators.setCreateRegistration(registration, url)) },
        getRegistration: (id: number, editkey: string): Promise<IQaRegistrationGetRegistrationResponse> => { return dispatch(QaRegistrationActionCreators.getRegistration(id, editkey)) }
    };
}

export default connect<IQaRegistrationStateProps, IQaRegistrationDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(QaRegistration);